import { getDefaultClosureName } from '@/components/EventTypeForm/FinalizationReport/utils/classification';

export const CONTACT_NOTIFICATION_BY_OPTIONS = ['email', 'whatsapp'];

export const createDefaultClosures = () => [
  {
    id: 'closure-positive',
    classification: 'positive',
    name: getDefaultClosureName('positive'),
    locked: true,
  },
  {
    id: 'closure-negative',
    classification: 'negative',
    name: getDefaultClosureName('negative'),
    locked: true,
  },
  {
    id: 'closure-neutral',
    classification: 'neutral',
    name: getDefaultClosureName('neutral'),
    isDefaultNeutral: true,
  },
];

export const normalizeClosures = (closures = []) => {
  if (!closures.length) return createDefaultClosures();

  const used = new Set();

  const takeFirst = (classification) => {
    const index = closures.findIndex(
      (closure, i) => closure.classification === classification && !used.has(i)
    );

    if (index === -1) return null;

    used.add(index);
    return closures[index];
  };

  const positive = takeFirst('positive');
  const negative = takeFirst('negative');
  const defaultNeutral = takeFirst('neutral');

  const result = [
    {
      id: positive?.id ?? 'closure-positive',
      classification: 'positive',
      name: positive?.name || getDefaultClosureName('positive'),
      locked: positive?.locked ?? true,
    },
    {
      id: negative?.id ?? 'closure-negative',
      classification: 'negative',
      name: negative?.name || getDefaultClosureName('negative'),
      locked: negative?.locked ?? true,
    },
  ];

  if (defaultNeutral) {
    result.push({
      id: defaultNeutral.id ?? 'closure-neutral',
      classification: 'neutral',
      name: defaultNeutral.name || getDefaultClosureName('neutral'),
      locked: defaultNeutral.locked ?? false,
      isDefaultNeutral: true,
    });
  }

  closures.forEach((closure, index) => {
    if (used.has(index)) return;

    result.push({
      id: closure.id ?? `closure-${index}`,
      classification: closure.classification,
      name:
        closure.name ||
        getDefaultClosureName(closure.classification ?? 'neutral'),
      locked: closure.locked ?? false,
    });
  });

  return result;
};

export const getFirstFreeContactNotificationOption = (items) => {
  const usedOptions = new Set(items.map((item) => item.by ?? item.via));

  return (
    CONTACT_NOTIFICATION_BY_OPTIONS.find(
      (option) => !usedOptions.has(option)
    ) ?? CONTACT_NOTIFICATION_BY_OPTIONS[0]
  );
};

export const normalizeContactNotificationItem = (item) => ({
  ...item,
  by: item.by ?? item.via ?? 'email',
});
